import { locationsProfilesService } from '@services';
import { locationsProfilesConstants } from '@constants/locations-profiles';

export const locationsProfilesActions = {
    get,
    reset,
};

function request() {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_FETCH };
}

function success(data) {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_SUCCESS, data };
}

function failure() {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_ERROR };
}

function reset() {
    return { type: locationsProfilesConstants.LOCATIONS_PROFILES_RESET };
}

function get(locationId) {
    return dispatch => {
        dispatch(request());
        locationsProfilesService.get(locationId).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
}
